import apiClient from './client';
import type {
  CompanyFinanceOverview,
  CompanyFinanceReconcileRequest,
  CompanyFinanceReconcileResponse,
} from '@/types/companyFinance';

export const companyFinanceApi = {
  getOverview: (period?: string) =>
    apiClient
      .get<CompanyFinanceOverview>('/company-finance/overview', {
        params: period ? { period } : undefined,
      })
      .then((response) => response.data),

  runReconciliation: (payload: CompanyFinanceReconcileRequest) =>
    apiClient
      .post<CompanyFinanceReconcileResponse>('/company-finance/reconcile', payload)
      .then((response) => response.data),
};
